export default __webpack_public_path__ + "static/media/arrow-right.64d31107.svg";